export default {"src":"/_next/static/media/back-arrow.18e67049.svg","height":18,"width":18};